module.exports = __webpack_public_path__ + "img/pre-start1.2d8aad33.png";